import { combineReducers } from '@reduxjs/toolkit';
import account from './account.slice';
import admin from './admin.slice';
import login from './loginSlice';
import user from './userSlice';

const authReducers = combineReducers({
  admin,
  user,
  login,
  account,
});

export default authReducers;
